module.exports = __webpack_public_path__ + "static/media/picture-footer.e24d183d.webp";